import { createContext, useContext } from "react";

export const SoviAiContext = createContext(null);

export const useSoviAi = () => useContext(SoviAiContext);
